// extracted by css-extract-rspack-plugin
export default {"comment-indicator":"DiffLineTableCellParts-module__comment-indicator__vfGSJ","in-progress-comment-indicator":"DiffLineTableCellParts-module__in-progress-comment-indicator__HpBNg"};